import { type RouteOutputOf, typedRoute } from "@d12labs/client";
import type { ledgerRouteDefs } from "../server/routes";

export const ledgerApi = {
	sessions: typedRoute<typeof ledgerRouteDefs.sessions>()("GET", "/api/plugins/ledger/sessions"),
	transcript: typedRoute<typeof ledgerRouteDefs.transcript>()(
		"GET",
		"/api/plugins/ledger/sessions/:id/transcript",
	),
	gaps: typedRoute<typeof ledgerRouteDefs.gaps>()("GET", "/api/plugins/ledger/gaps"),
};

export type LedgerSession = Awaited<ReturnType<typeof ledgerApi.sessions>>[number];
export type LedgerGap = Awaited<ReturnType<typeof ledgerApi.gaps>>[number];
export type LedgerTranscriptPage = RouteOutputOf<typeof ledgerRouteDefs.transcript>;
export type TranscriptMessage = LedgerTranscriptPage["items"][number];
export type TranscriptTool = TranscriptMessage["tools"][number];
